<div *ngIf="!formReady">
  Loading
</div>

<div [formGroup]="formData" class="form-host" *ngIf="formReady">
  <div class="form angularForm">
    <div class="title">
      Language definitions
    </div>
    <div class="info">
      Provide translations and localizations for Widgets
    </div>
    <section *ngIf="errorMessage">
        <p class="errorMsg">{{errorMessage}}</p>
    </section>
    <div class="block-info">
      <div class="block-info-title">
        Attributes
      </div>
      <div class="inline-elements">
        <div class="inline-item">
          <div class="inline-item-title">
            Language Name *
          </div>
          <input type="text" formControlName="description" required minlength="3" />
        </div>
        <div class="inline-item">
          <div class="inline-item-title">
            Default
          </div>
          <!-- changing of defualt language should be discussed -->
          <input class="dictionary-checkbox disabled" type="checkbox" formControlName="isDefault" />
        </div>
        <div class="inline-item">
          <div class="inline-item-title">
            Active
          </div>
          <!-- for now language definitions can be deleted (deactivated - using button in navigation) but not undeleted (reactivated) -->
          <input class="dictionary-checkbox" type="checkbox" formControlName="isActive" />
        </div>
        <div class="inline-item">
          <div class="inline-item-title">
            Locale
          </div>

          <kendo-dropdownlist formControlName="localeId"
                              [data]="reflistData.ref_l3_locale"
                              textField="description"
                              valueField="oid"
                              [valuePrimitive]="true"
                              required>
          </kendo-dropdownlist>
        </div>
      </div>

      <div class="inline-elements">
        <div class="inline-item dictionary-input-text">
          <div class="inline-item-title">
            ID
          </div>
          <input type="number" formControlName="id" class="no-border-bottom" />
        </div>
        <div class="inline-item dictionary-input-text">
          <div class="inline-item-title">
            Created By
          </div>
          <input type="text" formControlName="createdByDescription" class="no-border-bottom" />
        </div>
        <div class="inline-item">
          <div class="inline-item-title">
            Created On
          </div>
          <kendo-datepicker class="dictionary-date" required formControlName="createdOn" style="margin-top: 10px;">
          </kendo-datepicker>
        </div>
      </div>
    </div>
    <div class="button-control">
      <button class="button-export-template spacing-right" (click)="close()">
        Close
      </button>
      <button class="button-export-template" (click)="save()">
        Save
      </button>
    </div>
  </div>
</div>
